import isLocalStorageAvailable from 'shared/utils/isLocalStorageAvailable';
import { Map } from 'immutable';
import {
	CLOSE_CANCEL_CONFIRM_MODAL,
	CLOSE_EXIT_CONFIRM_MODAL,
	OPEN_CANCEL_CONFIRM_MODAL,
	OPEN_EXIT_CONFIRM_MODAL,
	SET_SALESPERSON_ID,
	DESTROY_SALESPERSON_ID,
	SET_APPLICATION_FORM_DATA,
	DESTROY_APPLICATION_FORM_DATA,
} from './constants';

export const salespersonIdKey = 'salespersonId';
export const applicationFormDataKey = 'applicationFormData';

export const getSalespersonIdFromLocalStorage = () => {
	if (isLocalStorageAvailable()) {
		return localStorage.getItem(salespersonIdKey) || '';
	}
	return '';
};

export const getApplicationFormDataFromLocalStorage = () => {
	if (isLocalStorageAvailable()) {
		return localStorage.getItem(applicationFormDataKey) || '';
	}
	return '';
};

export const initialState = Map({
	isCancelConfirmModalOpen: false,
	isExitConfirmModalOpen: false,
	salespersonId: getSalespersonIdFromLocalStorage(),
	applicationFormData: getApplicationFormDataFromLocalStorage(),
});

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case CLOSE_CANCEL_CONFIRM_MODAL:
			return state.merge({ isCancelConfirmModalOpen: false });
		case CLOSE_EXIT_CONFIRM_MODAL:
			return state.merge({ isExitConfirmModalOpen: false });
		case OPEN_CANCEL_CONFIRM_MODAL:
			return state.merge({ isCancelConfirmModalOpen: true });
		case OPEN_EXIT_CONFIRM_MODAL: {
			return state.merge({ isExitConfirmModalOpen: true });
		}
		case SET_SALESPERSON_ID:
			if (isLocalStorageAvailable()) {
				localStorage.setItem(salespersonIdKey, action.id);
			}
			return state.merge({ salespersonId: action.id });
		case DESTROY_SALESPERSON_ID:
			localStorage.setItem(salespersonIdKey, '');
			return state.set('salespersonId', '');
		case SET_APPLICATION_FORM_DATA:
			if (isLocalStorageAvailable()) {
				localStorage.setItem(applicationFormDataKey, action.formValues);
			}
			return state.merge({ applicationFormData: action.formValues });
		case DESTROY_APPLICATION_FORM_DATA:
			localStorage.setItem(applicationFormDataKey, '');
			return state.set('applicationFormData', '');
		default:
			return state;
	}
};

export default reducer;
